export class ApplicationCompany {
  public id: number;
  public applicationId: number;
  public applicationName: string;
  public companyId: number;
  public msBaseUrl: string;
  public app_icon: string;
}



// WEBPACK FOOTER //
// ./src/app/models/applicationCompany.model.ts